import pagesNames from "../../constants/pages-names";

const footerDataAr = {
    rowOne : {
        title : "News",
        columns : [
            {
                image : {
                    name : "img-1.jpg",
                    alt : "",
                },
                link : {
                    text : "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
                    path : pagesNames.home,
                },
                subtext : "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
            },
            {
                image : {
                    name : "img-2.jpg",
                    alt : "",
                },
                link : {
                    text : "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
                    path : pagesNames.home,
                },
                subtext : "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
            },
        ],
        button : {
            text : "Read More",
            path : pagesNames.home,
        },
    },
    rowTwo : {
        title : "Insights",
        columns : [
            {
                image : {
                    name : "img-3.jpg",
                    alt : "",
                },
                link : {
                    text : "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
                    path : pagesNames.home,
                },
                subtext : "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
            },
            {
                image : {
                    name : "img-4.jpg",
                    alt : "",
                },
                link : {
                    text : "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
                    path : pagesNames.home,
                },
                subtext : "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
            },
        ],
        button : {
            text : "Read More",
            path : pagesNames.home,
        },
    },
    sectionTwo : {
        listOne : [
            {
                text : "استراتيجيتنا",
                discription : "انتقل إلى خطتنا الاستراتيجيةe",
                path : pagesNames.starategy,
            },
            {
                text : "التزاماتنا",
                discription : "انتقل إلى صفحة التزاماتنا",
                path : pagesNames.commitments,
            },
            {
                text : "رحلتنا",
                discription : "Go to esg journey page",
                path : pagesNames.journey,
            },
        ],
        listTow : [
            {
                text : "الأخبار",
                discription : "Go to news page",
                path : pagesNames.news,
            },
            {
                text : "الرؤى",
                discription : "Go to insights page",
                path : pagesNames.insight,
            },
        ],
        listThree : [
            {
                text : "البيانات والسياسات",
                discription : "انتقل إلى صفحة البيانات والسياسات",
                path : pagesNames.statements,
            },
            {
                text : "محور الموارد",
                discription : "نتقل إلى صفحة محور الموارد",
                path : pagesNames.resource,
            },
        ],
        listFour : [
            {
                text : "تحميل",
                discription : "انتقل إلى صفحة التنزيلات",
                path : pagesNames.home,
            },
        ],
        listFive : [
            {
                image : {
                    name : "twitter-icon.svg",
                    description : "انظر حسابنا على تويتر",
                    alt : "twitter icon",
                },
                path : "https://twitter.com",
            },
            {
                image : {
                    name : "facebook-icon.svg",
                    description : "انظر صفحتنا على الفيسبوك",
                    alt : "facebook icon",
                },
                path : "https://www.facebook.com/",
            },
            {
                image : {
                    name : "instagram-icon.svg",
                    description : "شاهد حسابنا على الانستغرام",
                    alt : "instagram icon",
                },
                path : "https://www.instagram.com",
            },
            {
                image : {
                    name : "linkedin.svg",
                    description : "See our linkedin account",
                    alt : "linkedin icon",
                },
                path : "https://www.linkedin.com/company/alawwalsab"
            },
        ]
    }
}

export default footerDataAr;